// File: src/MathTools/ElementaryMathHelperTool.js

import React, { useState, useEffect } from "react";

/**
 * InteractiveGraphSection – a simple interactive bar graph for inputting values
 * Props:
 *  - graphCanvasRef: useRef to a canvas element
 *  - initialData: array of {label, value}
 *  - drawGraphOnCanvas: function(canvas, data)
 */
export function InteractiveGraphSection({ graphCanvasRef, initialData, drawGraphOnCanvas }) {
  const [graphData, setGraphData] = useState(initialData);

  useEffect(() => {
    if (drawGraphOnCanvas && graphCanvasRef.current) {
      drawGraphOnCanvas(graphCanvasRef.current, graphData);
    }
  }, [graphData, graphCanvasRef, drawGraphOnCanvas]);

  return (
    <div>
      {graphData.map((item, i) => (
        <div key={i} style={{ marginBottom: "5px" }}>
          <label>
            {item.label}:{" "}
            <input
              type="number"
              value={item.value}
              onChange={(e) => {
                const newData = [...graphData];
                newData[i].value = parseInt(e.target.value) || 0;
                setGraphData(newData);
              }}
              style={{ width: "50px" }}
            />
          </label>
        </div>
      ))}
      <div className="graph-container" style={{ marginTop: 20 }}>
        <canvas
          ref={graphCanvasRef}
          width="300"
          height="200"
          className="graph-canvas"
        />
      </div>
      <p>
        The graph shows each pet on the horizontal axis and the number of votes on the vertical axis.
      </p>
    </div>
  );
}

/**
 * DynamicPizza – demo a pizza fraction using a slider
 */
export function DynamicPizza() {
  const [den, setDen] = useState(2);
  const angle = 360 / den;
  return (
    <div className="dynamic-pizza-container">
      <h2>Fraction slider: 1 / {den}</h2>
      <input
        type="range"
        min="2"
        max="10"
        value={den}
        onChange={(e) => setDen(+e.target.value)}
      />
      <div
        className="pizza-disc"
        style={{
          background: `conic-gradient(#f1c40f 0deg, #f1c40f ${angle}deg, #fff ${angle}deg 360deg)`,
        }}
      />
      <p>{((1 / den) * 100).toFixed(0)} % of the pizza</p>
    </div>
  );
}

/**
 * MultiplicationTable – renders a 9x9 multiplication chart
 */
export function MultiplicationTable() {
  return (
    <table className="multiplication-table">
      <tbody>
        {Array.from({ length: 9 }, (_, r) => (
          <tr key={r}>
            {Array.from({ length: 9 }, (_, c) => (
              <td key={c}>{`${r + 1} × ${c + 1} = ${(r + 1) * (c + 1)}`}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

/**
 * drawShapeOnCanvas – draws a simple 2D shape on the canvas (by idx)
 * Shapes: triangle, square, circle, pentagon, hexagon
 */
export function drawShapeOnCanvas(canvas, idx) {
  if (!canvas) return;
  const ctx = canvas.getContext("2d");
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.strokeStyle = "#007bff";
  ctx.lineWidth = 3;
  ctx.beginPath();
  switch (idx) {
    case 0: // triangle
      ctx.moveTo(100, 20);
      ctx.lineTo(50, 110);
      ctx.lineTo(150, 110);
      ctx.closePath();
      break;
    case 1: // square
      ctx.rect(60, 40, 80, 80);
      break;
    case 2: // circle
      ctx.arc(100, 80, 40, 0, Math.PI * 2);
      break;
    case 3: // pentagon
      ctx.moveTo(100, 20);
      ctx.lineTo(50, 60);
      ctx.lineTo(70, 120);
      ctx.lineTo(130, 120);
      ctx.lineTo(150, 60);
      ctx.closePath();
      break;
    default: // hexagon
      ctx.moveTo(100, 20);
      ctx.lineTo(60, 50);
      ctx.lineTo(60, 90);
      ctx.lineTo(100, 120);
      ctx.lineTo(140, 90);
      ctx.lineTo(140, 50);
      ctx.closePath();
      break;
  }
  ctx.stroke();
}
